import React from 'react'
import cn from 'classnames'

import { ChevronUpIcon } from '@components/icons/ChevronUpIcon'
import { AccordionProps } from './interface'

export function Accordion({
  title,
  children,
  disabled,
  className,
  active,
  rotate,
  contentSpace,
  toggleAccordion,
}: AccordionProps) {
  return (
    <div className='flex flex-col'>
      <button
        type='button'
        disabled={disabled}
        className={cn(
          className,
          'box-border text-secondary-1 appearance-none cursor-pointer focus:outline-none flex items-center justify-between dark:bg-dark-9',
          {
            'cursor-no-drop opacity-40': disabled,
          }
        )}
        onClick={toggleAccordion}
      >
        <div className='flex items-center'>
          <div className='text-base font-bold text-secondary inline-block dark:text-dark-10'>
            {title}
          </div>
        </div>
        <ChevronUpIcon className={cn('text-primary', rotate)} />
      </button>
      <div
        ref={contentSpace}
        style={{ maxHeight: active ? `700px` : `0px` }}
        className='overflow-auto transition-max-height duration-300 ease-in-out'
      >
        <div>{children}</div>
      </div>
    </div>
  )
}

Accordion.defaultProps = {
  className: 'bg-gray-4 h-[60px] py-[18px] px-5 mobile:px-[10px] mt-[1px]',
}
